export const API_GW_URL="https://api.test-pettrak.kynetec.com"
export const CLIENT_ID="d35739a2-870c-4c7b-be12-717b35b31f95"
export const ENVIRONMENT="test"
